import React,{useEffect,useState,useContext} from 'react'
import axios from 'axios'
import { AuthContextUser } from "../context/UserContext";
import { ToastContainer, toast } from "react-toastify";

export const Profile = () => {

    const { currentUser } = useContext(AuthContextUser);

    const [findeLoc, setFindLoc] = useState([]);

    useEffect(() => {
      const getAllLetterData = async () => {
        const resT = await fetch(
          `https://clinic.salamatpayanew.ir/Register/ProfileList/${currentUser.tel}`
        );
        setFindLoc(await resT.json());
      };
      getAllLetterData();
    }, []);

const [name,setName] = useState(currentUser.name)
const [avg,setAvg] = useState(currentUser.avg)
const [io1,setIo1] = useState(currentUser.io1)
const [io2,setIo2] = useState(currentUser.io2)
const [addr,setAddr] = useState(currentUser.addr)
const [acu,setAcu] = useState(currentUser.acu)
const [day,setDay] = useState(currentUser.day)
const [month,setMonth] = useState(currentUser.month)
const [year,setYear] = useState(currentUser.year)

const updateProfile = async () => {
     try{
        await axios
        .put(
          `https://clinic.salamatpayanew.ir/StudentUpdate/UpdateProfile/${currentUser.tel}`,
          {
                name:name,
                 year:year,
                 month:month,
                 day:day,
                 io1:io1,
                 io2:io2,
                 addr:addr,
                 avg:avg,
                 acu:acu
          }
        )
        .then(() => {
          toast.success("ویرایش انجام شد");
        })
        .catch(() => {
          toast.error("خطا در ویرایش اطلاعات");
        });
        }catch(e){
            toast.error("خطا در عملیات")
        }
}

if (currentUser.tel === null) {
} else {
  return (
    <>
    
    <section class="m-0 content" dir='rtl'>
        <div class="d-flex flex-column justify-content-start align-items-center">
            <div class="card">
                <img src="../img/dr01.png" class="position-absolute form-img" alt="" />
                <div class="d-flex flex-column justify-content-start card-title-container">
                    <div class="card-title text-secondary">تکمیل نهایی رو انجام بده</div>
                    <p class="card-subtitle">اطلاعات پروفایل شما کامل نیست لطفا ابتدا فرم زیر را تکمیل
                        نمایید </p>
                </div>
                <div class="d-flex flex-column w-100" id="data_parent">
                    <div class="d-flex flex-column flex-md-row justify-content-between w-100 t-24">                                           
                    <div class="custom-form-control form-group position-relative w-50">
                        <input type="text" class="form-control pr-16 my-2" placeholder="نام" value={name}  onChange={(e) => setName(e.target.value)} />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 mx-xl-3">
                        <input type="text" class="form-control pr-16 my-2" placeholder="مقطع" value={io1}  onChange={(e) => setIo1(e.target.value)} />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 mx-xl-3">
                        <input type="text" class="form-control pr-16 my-2" placeholder="مقطع" value={io2}  onChange={(e) => setIo2(e.target.value)} />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 mx-xl-3">
                            <input type="text" class="form-control" placeholder="معدل" value={avg}  onChange={(e) => setAvg(e.target.value)}/>
                        </div>
                    </div>
                    <div class="d-flex flex-column flex-md-row justify-content-between w-100">
                        <div class="custom-form-control form-group position-relative w-50 m-0 mx-xl-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="نام موسسه آموزشی" value={acu}  onChange={(e) => setAcu(e.target.value)}/>
                        </div>
                        <div class="custom-form-control form-group position-relative w-10 m-0 mx-xl-3">
                            <input type="text" class="form-control pr-16 my-2 flatpickr-date"
                                   placeholder="روز" value={day}  onChange={(e) => setDay(e.target.value)}/>
                        </div>
                        <div class="custom-form-control form-group position-relative w-10 m-0 mx-xl-3">
                            <input type="text" class="form-control pr-16 my-2 flatpickr-date"
                                   placeholder="ماه" value={month}  onChange={(e) => setMonth(e.target.value)}/>
                        </div>
                        <div class="custom-form-control form-group position-relative w-10 m-0 mx-xl-3">
                            <input type="text" class="form-control pr-16 my-2 flatpickr-date"
                                   placeholder="سال" value={year}  onChange={(e) => setYear(e.target.value)}/>
                        </div>
                    </div>
                </div>
                <div class="form-group position-relative w-100">
                    <textarea class="form-control-text my-0 p-3" name="" id="" cols="30" rows="10"
                              placeholder="آدرس" value={addr}  onChange={(e) => setAddr(e.target.value)}>

                        </textarea>
                </div>
                <button class="custom-btn-primary t-24 form-submit p-16" onClick={updateProfile}>
                    ارسال و تکمیل پروفایل
                </button>
            </div>
        </div>
    </section>
    <ToastContainer
        position="top-center"
        autoClose={20000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  )
 }
}
